(function() {
  'use strict';

  angular.module('app.tracts')
    .controller('CreateTractCtrl', ['$uibModalInstance', 'message', 'totalPrice', 'totalLandValue', 'totalBldgsValue', 'totalTimberValue', 'totalAssessments', 'totalAcres', 'nearestCity', 'politicalSub', 'firstParcelData', 'domains', 'tract', 'pictures', 'comments', 'selectedFeatures', 'tracts', '$scope',
      function($uibModalInstance, message, totalPrice, totalLandValue, totalBldgsValue, totalTimberValue, totalAssessments, totalAcres, nearestCity, politicalSub, firstParcelData, domains, tract, pictures, comments, selectedFeatures, tracts, $scope) {
        let vm = this;
        // console.log('pictures ', pictures);
        vm.idSelectedImage = null;
        vm.selectedImage;
        vm.pictures = pictures;
        vm.message = message;
        vm.creatingTract = false;
        vm.error = false;
        vm.tract = {};
        if (totalPrice !== 0) {
          vm.tract.Start_bid_price = totalPrice; // jshint ignore:line
        }
        vm.tract.Land_price = totalLandValue; // jshint ignore:line
        vm.tract.Imp_price = totalBldgsValue; // jshint ignore:line
        vm.tract.Timber_price = totalTimberValue; // jshint ignore:line
        vm.tract.Special_price = totalAssessments; // jshint ignore:line
        vm.tract.Acres = totalAcres;
        vm.tract.NearestCity = nearestCity;
        vm.tract.Political_Sub = politicalSub; // jshint ignore:line
        vm.firstParcel = firstParcelData;
        vm.tract.Tract = tract;
        vm.tract.m_comments = comments;
        // set the address and structure information
        // if (firstParcelData.attributes.PhysAddr === '') {
        //   firstParcelData.attributes.PhysAddr = 'No address available';
        // }
        // TODO: setup all date fields using the setup date fields function
        if (vm.firstParcel.attributes.Last_LS_date != null) { // jshint ignore:line
          let theDate = new Date(vm.firstParcel.attributes.Last_LS_date); // jshint ignore:line
          vm.tract.Last_LS_date = { // jshint ignore:line
            date: new Date(theDate.getTime() + theDate.getTimezoneOffset() * 60000),
            opened: false
          };
        } else {
          vm.tract.Last_LS_date = { // jshint ignore:line
            date: null,
            opened: false
          };
        }
        // _setupAllDates();
        vm.tract.PhysAddr = firstParcelData.attributes.PhysAddr;
        vm.tract.PhysCity = firstParcelData.attributes.PhysCity;
        vm.tract.PhysZip = firstParcelData.attributes.PhysZip;
        vm.tract.StructurePresent = firstParcelData.attributes.StructurePresent;
        vm.tract.StructureDescription = firstParcelData.attributes.StructureDescription;
        vm.tract.PIN = firstParcelData.attributes.PIN;
        vm.tract.Block = firstParcelData.attributes.Block;
        vm.tract.Sec = firstParcelData.attributes.Sec;
        vm.tract.Twp = firstParcelData.attributes.Twp;
        vm.tract.Rnge = firstParcelData.attributes.Rnge;
        vm.tract.Legals = firstParcelData.attributes.Legals;
        vm.tract.PlatDesc = firstParcelData.attributes.PlatDesc;

        // date format
        vm.dateFormat = 'MM/dd/yyyy';

        vm.fOpenStart = function(item) {
          item.open = true;
        };

        vm.fOpenEnd = function() {
          vm.fEndDate.open = true;
        };

        vm.createTract = function(isValid) {
          // console.log('valid form? ', isValid);
          // console.log('creating tract? ', vm.creatingTract);
          // console.log('the form: ', $scope);
          $scope.newTract.$setSubmitted();
          if (isValid) {
            vm.error = false;
            vm.creatingTract = true;
            // combine the image and the tract attributes so they can be returned from the promise at the same time
            let result = [];
            result.push(vm.tract);
            result.push(vm.selectedImage);
            tracts._unionGeometry()
              .then(function(geometry) {
                result[0].PIN = tracts.getAllPins();
                result[0].Lot = tracts.getAllLotNums();
                result[0].Judgement_Year = tracts.getAllJudgementYrs(); // jshint ignore:line
                // FIXME: doesn't account for multiple different forfeiture dates
                // result[0].Forfeiture_date = tracts.getAllForfeitDates();

                // calculate the lat/long of the centroid for the direction fields
                tracts._calcCentroidAndLinks(geometry, result[0])
                  .then(function(attributes) {
                    // console.log('ATTRIBUTES', attributes, geometry, result[1]);
                    tracts._saveNewTract(attributes, geometry, result[1])
                      .then(function(result) {
                        if (result !== 'error') {
                          vm.creatingTract = false;
                          $uibModalInstance.close(result);
                        } else {
                          vm.creatingTract = false;
                          vm.error = true;
                        }
                      });
                  });
              });
          }
        };

        vm.cancel = function() {
          $uibModalInstance.close('cancel');
        };

        vm.getDomainValues = function(field) {
          return _.find(domains, {
            'name': field
          }).domain.codedValues;
        };

        vm.selectImage = function(image) {
          vm.idSelectedImage = image.id;
          vm.selectedImage = image;
        };

        // function _setupAllDates(field) {
        //   if (vm.parcel.attributes[field] !== null) {
        //     let theDate = new Date(vm.parcel.attributes[field]);
        //     vm.parcel.attributes[field] = {
        //       date: new Date(theDate.getTime() + theDate.getTimezoneOffset()*60000),
        //       opened: false
        //     };
        //   } else {
        //     vm.parcel.attributes[field] = {
        //       date: null,
        //       opened: false
        //     };
        //   }
        // }

      }
    ]);
}());
